<div class="footer">
  <div class="header">
    {{ 'footer.title' | translate }}
  </div>
  <div class="rows-container">
    <div class="row">
      <div class="icon icon-edit"></div>
      <div class="text">
        <div class="row-title">{{ 'footer.rows.0.title' | translate }}</div>
        <div class="row-content">{{ 'footer.rows.0.content' | translate }}</div>
      </div>
    </div>
    <div class="row">
      <div class="icon icon-paper"></div>
      <div class="text">
        <div class="row-title">{{ 'footer.rows.1.title' | translate }}</div>
        <div class="row-content">{{ 'footer.rows.1.content' | translate }}</div>
      </div>
    </div>
    <div class="row">
      <div class="icon icon-heart"></div>
      <div class="text">
        <div class="row-title">{{ 'footer.rows.2.title' | translate }}</div>
        <div class="row-content">{{ 'footer.rows.2.content' | translate }}</div>
      </div>
    </div>
  </div>
</div>
